import React, { ReactNode, useState } from 'react'
import { IFaq } from '@et/types/Courses'
import { GridFluid } from '@styles/global/cssGrid'
import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'
import FaqItemB from '@components/sections/faqs/faqItemLayoutB'
import FaqItemC from '@components/sections/faqs/faqItemLayoutC'
import HeaderLayoutA_V4 from '@components/headers/headerLayoutA_v4'

interface IProps {
  dangerouslySetAnswers?: boolean
  faqs: IFaq[]
  textColor?: string
  textActivatedColor?: string
  textureImg?: ReactNode
  illustrationImg?: ReactNode
  subHead?: string
  title?: string
}

type State = null | number

function FaqLayoutB({ faqs, textColor, textActivatedColor, textureImg, illustrationImg, dangerouslySetAnswers, subHead = `HERE TO HELP`, title = `Frequently Asked Questions` }: IProps) {
  const [selectedItem, setSelectedItem] = useState<State>(null)

  function handleItemClick(itemIndex?: number | null) {
    if (itemIndex || itemIndex === 0) {
      setSelectedItem(itemIndex)
    } else {
      setSelectedItem(null)
    }
  }

  return (
    <Wrapper>
      <HeaderLayoutA_V4
        bgImg={illustrationImg}
        texture={{
          img: textureImg,
        }}
        subHead={subHead}
        title={title}
      />
      <FaqWrapper>
        {faqs && !dangerouslySetAnswers && faqs.map((faq: IFaq, index: number) => (
          <FaqItemB
            textColor={textColor}
            textActivatedColor={textActivatedColor}
            key={index}
            itemIndex={index}
            handleClick={handleItemClick}
            selectedItem={selectedItem}
            {...faq}
          />
        ))}
        {faqs && dangerouslySetAnswers && faqs.map((faq: IFaq, index: number) => (
          <FaqItemC
            textColor={textColor}
            textActivatedColor={textActivatedColor}
            key={index}
            itemIndex={index}
            handleClick={handleItemClick}
            selectedItem={selectedItem}
            {...faq}
          />
        ))}
      </FaqWrapper>
    </Wrapper>
  )
}

const Wrapper = styled(GridFluid)`
  margin: 60px 0 0;
  grid-row-gap:0;
  @media ${device.tablet} {
    margin: 90px 0 0;
  }
  	
`
const FaqWrapper = styled.div`
  grid-column: 2 / -1;
  padding-left: 30px;
  
  @media ${device.tablet}{
    padding-left: 0;
    grid-column: 4 / -1;
  }
  
  a{
    &:hover{
      cursor: pointer;
    }
  }
`
export default FaqLayoutB
